import Vue from 'vue';
import PageNav from './page-nav.vue';

const pageNavContainer = document.querySelectorAll('.z-page__nav');

document.addEventListener('DOMContentLoaded', () => {
    if (pageNavContainer.length > 0) {
        for (let index = 0; index < pageNavContainer.length - 1; index++) {
            new Vue({
                el: pageNavContainer[index],
                components: { PageNav }
            });
        }
    };
});




// WEBPACK FOOTER //
// ./frontend/components/page-nav/page-nav.js